import script from "./CategoryFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryFilters.vue?vue&type=script&setup=true&lang=js"

import "./CategoryFilters.vue?vue&type=style&index=0&id=238115b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-238115b4"]])

export default __exports__